import React, { useEffect, useState } from 'react';
import { GlobalContext } from './GlobalContext';
import { useGetMaterias } from '../hooks/useGetMaterias';
import { useNavigate } from 'react-router-dom';

export const GlobalContextProvider = ({ children }) => {

    const navigate = useNavigate();
    const { data, loading } = useGetMaterias();
    const [Calificaciones, setCalificaciones] = useState(null);

    const [darkTheme, setDarkTheme] = useState(localStorage.getItem('darkTheme') ? true : false);
    const [isMobile, setIsMobile] = useState(true);
    const toggleTheme = checked => {
        if (checked)
            localStorage.setItem('darkTheme', true);
        else
            localStorage.removeItem('darkTheme');
        setDarkTheme(checked)
    }

    useEffect(() => {
        if (!loading) {
            if (data === 401) {
                if (isMobile) {
                    navigate('/401');
                } else {
                    window.location.href = '/Auth/login';
                }
                
            }
            if (data === 400) {
                navigate('/400');
            }
            if(data.colaborador === true){
                navigate('/Colaborador');
            }
            setCalificaciones(data);
        }
    }, [navigate, data, loading, isMobile])

    return (
        <GlobalContext.Provider value={{ Calificaciones, loading, darkTheme, toggleTheme, isMobile, setIsMobile }}>
            {children}
        </GlobalContext.Provider>
    )
}
